import type { TranslationKey } from '@/i18n-key';
import type { ThematicMeetingTopic } from '@/types/thematic-meetings';

/**
 * The name of each meeting topic, translated by us rather than read from a plan: a company may hold
 * several plans for one topic, each titled its own way, while the topic itself keeps one name
 * wherever it is offered.
 */
export const THEMATIC_MEETING_TOPIC_LABEL_KEYS: Record<ThematicMeetingTopic, TranslationKey> = {
    Skill: 'thematicMeetings.topics.skill.label',
    Recurring: 'thematicMeetings.topics.recurring.label',
    Goals: 'thematicMeetings.topics.goals.label',
    Feedback: 'thematicMeetings.topics.feedback.label',
    Career: 'thematicMeetings.topics.career.label',
    Recognition: 'thematicMeetings.topics.recognition.label',
    Workload: 'thematicMeetings.topics.workload.label',
    Team: 'thematicMeetings.topics.team.label',
    Informal: 'thematicMeetings.topics.informal.label',
};
